var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSessionCallIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4322_18422",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4322_18422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3 14C11.8667 14 10.4696 13.6804 9.10867 13.0413C7.74733 12.4027 6.54178 11.5582 5.492 10.508C4.44178 9.45822 3.59733 8.25267 2.95867 6.89133C2.31956 5.53044 2 4.13333 2 2.7C2 2.5 2.06667 2.33333 2.2 2.2C2.33333 2.06667 2.5 2 2.7 2H5.4C5.55556 2 5.69444 2.05 5.81667 2.15C5.93889 2.25 6.01111 2.37778 6.03333 2.53333L6.46667 4.86667C6.48889 5.02222 6.48622 5.16378 6.45867 5.29133C6.43067 5.41933 6.36667 5.53333 6.26667 5.63333L4.65 7.26667C5.11667 8.06667 5.70289 8.81667 6.40867 9.51667C7.114 10.2167 7.88889 10.8222 8.73333 11.3333L10.3 9.76667C10.4 9.66667 10.5307 9.59156 10.692 9.54133C10.8529 9.49156 11.0111 9.47778 11.1667 9.5L13.4667 9.96667C13.6222 10 13.75 10.0749 13.85 10.1913C13.95 10.3082 14 10.4444 14 10.6V13.3C14 13.5 13.9333 13.6667 13.8 13.8C13.6667 13.9333 13.5 14 13.3 14ZM4.01667 6L5.11667 4.9L4.83333 3.33333H3.35C3.40556 3.78889 3.48333 4.23889 3.58333 4.68333C3.68333 5.12778 3.82778 5.56667 4.01667 6ZM9.98333 11.9667C10.4167 12.1556 10.8584 12.3056 11.3087 12.4167C11.7584 12.5278 12.2111 12.6 12.6667 12.6333V11.1667L11.1 10.85L9.98333 11.9667Z",
    fill: "#1DA687"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionCallIcon);
export default __webpack_public_path__ + "static/media/session-call-icon.2a49ba13f9b2e79db626ae187fc0195a.svg";
export { ForwardRef as ReactComponent };